import { render, staticRenderFns } from "./ContentWrap.vue?vue&type=template&id=d01183ca&scoped=true"
import script from "./ContentWrap.vue?vue&type=script&lang=js"
export * from "./ContentWrap.vue?vue&type=script&lang=js"
import style0 from "./ContentWrap.vue?vue&type=style&index=0&id=d01183ca&prod&lang=css"
import style1 from "./ContentWrap.vue?vue&type=style&index=1&id=d01183ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01183ca",
  null
  
)

export default component.exports